import { Campanha, Data, DataItem, useOperador } from "../../../context/OperadorContext";
import { formatMoney } from "../../../utils/formatMoney";
import { Loader } from "../../generics/loader";
import { useEffect, useMemo, useState } from "react";
import { Input } from "../ui/input";
import { useWhatsAppCampaign } from "../../../context/WhatsAppCampaignContext";
import { MessageCircle } from "lucide-react";
import { Button } from "../ui/button";
import { FaFileExcel } from "react-icons/fa";
import ExcelJS from "exceljs";
import { format } from "date-fns";
import { ModalRelatoriosWhats } from '../modal-whatsapp/modal-relatorios'

interface ListInfoDadosFilaProps {
    data: Data | null;
}

export default function ListInfoDadosFila({ data }: ListInfoDadosFilaProps) {

    const [contratos, setConratos] = useState<number>(0);
    const [filas, setFilas] = useState<number>(0);
    const [totalValorVencido, setTotalValorVencido] = useState<number>(0);
    const [totalValorVencer, setTotalValorVencer] = useState<number>(0);
    const [open, setOpen] = useState(false)
    const { campanhas, getRelatorioCampanha } = useOperador()

    const {
        queueLimit,
        setQueueLimit,
        setIsModalOpen,
        applyQueueLimit,
    } = useWhatsAppCampaign()

    function limitePermitido(limite: string) {
        const element = document.getElementById('queue-limit') as HTMLInputElement;
        applyQueueLimit()

        const limiteNumber = Number(queueLimit)

        const limiteFinal = !queueLimit || Number.isNaN(limite) || limiteNumber <= 0

        if (!limiteFinal && data?.orcamento_diario?.utility_disponivel && limiteNumber > data?.orcamento_diario?.utility_disponivel) {
            element.style.border = "2px solid red";
            return;
        }
        element.style.border = "";
        return;

    }

    async function downloadCSV() {

        if (campanhas && campanhas?.length > 1) {
            setOpen(true)
            return
        }

        const { campanha, item_campanha } = await getRelatorioCampanha(campanhas[0].id_campanha || 0) as unknown as { campanha: Campanha, item_campanha: { cpf_cnpj: string, telefone: string, status: string, data_campanha: string }[] }
        const rightAlign = [6, 7];
        const workbook = new ExcelJS.Workbook();
        const sheet = workbook.addWorksheet("Relatório Envio WhatsApp");
        const header = sheet.addRow([
            "CPF/CNPJ",
            "Telefone",
            'Data Hora Envio',
            "Status",
            "Nome Template",
            'Qtd. Envios',
            'Custo Total',
        ])
        header.eachCell((cell) => {
            cell.style = {
                font: {
                    bold: true,
                },
            };
        });

        sheet.addRow([
            `TOTAL CAMPANHA ${campanha.id_campanha}`,
            `LOJA - ${campanha.cod_empresa_gazin}`,
            format(new Date(campanha.data_hora_criacao), 'dd/MM/yyyy HH:mm:ss'),
            campanha.status ? 'Ativa' : 'Finalizada',
            campanha.template,
            campanha.quant_envio,
            campanha.custo,

        ])
        sheet.addRow([
            '',
            '',
            '',
            '',
            '',
        ])
        for (const item of item_campanha) {
            sheet.addRow([
                item.cpf_cnpj,
                item.telefone,
                item.data_campanha ? format(new Date(item.data_campanha), 'dd/MM/yyyy HH:mm:ss') : '',
                item.status
            ])
        }
        sheet.eachRow((row) => {
            row.eachCell((cell, col) => {
                if (rightAlign.includes(col)) {
                    cell.alignment = { horizontal: "right" };
                } else {
                    cell.alignment = { horizontal: "left" };
                }
            });
        });
        sheet.columns.forEach((column) => {
            const lengths = column?.values?.map((v) => (v ?? 0).toString().length);
            const maxLength = Math.max(
                ...(lengths ?? []).filter((v) => typeof v === "number")
            );

            column.width = maxLength + 5;
            column?.eachCell &&
                column.eachCell((cell) => {
                    cell.font = {
                        ...cell.font,
                        name: "Calibri",
                    };
                });
        });

        workbook.xlsx
            .writeBuffer()
            .then((buffer) => {
                const blob = new Blob([buffer], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });
                const url = URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;
                const date = new Date().getDate();
                link.setAttribute("download", `Relatório Envio WhatsApp ${date}.xlsx`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            })
            .catch((error) => {
                console.error("Error generating Excel file:", error);

            })

    }

    useEffect(() => {

        if (data?.data?.length === 0) {
            return;
        }

        const totalContratos = data?.data.length ?? 0;
        setConratos(totalContratos);

        const hoje = new Date().toISOString().split('T')[0];

        const totalFilaLoja = data?.data.length ?? 0;

        //  const totalFilaLoja = data?.data.filter(item => {
        //     if (!item.data_agendamento) return false;

        //     const dataAgendamento = item.data_agendamento.split('T')[0];
        //     return dataAgendamento < hoje;
        // }).length ?? 0;

        setFilas(totalFilaLoja);

        const { totalVencido, totalAVencer } = data?.data
            .reduce(
                (acc, item) => {
                    acc.totalVencido += Number(item.valor_vencido) || 0;
                    acc.totalAVencer += Number(item.valor_a_vencer) || 0;
                    return acc;
                },
                { totalVencido: 0, totalAVencer: 0 }
            ) ?? { totalVencido: 0, totalAVencer: 0 };

        setTotalValorVencido(totalVencido);
        setTotalValorVencer(totalAVencer);

    }, [data]);

    return (
        <div className="mt-2 flex w-[100%] space-x-4">
            {!data ? (
                <div className="flex w-[100%] items-center justify-center rounded-lg border p-4">
                    <Loader />
                </div>
            ) : (
                <>


                    <div className="grid grid-cols-2 gap-4  w-full">
                        {/* Resultado dos Filtros */}
                        <div className="bg-white rounded-lg border border-gray-200 p-4">
                            <h3 className="text-sm font-medium text-blue-600 mb-3 border-l-4 border-blue-600 pl-2">
                                Resultado dos Filtros
                            </h3>
                            <div className="grid grid-cols-4 gap-4">
                                <div className="bg-blue-50 p-2 rounded">
                                    <p className="text-lg font-bold text-blue-600">{filas}</p>
                                    <p className="text-xs text-blue-600">Fila loja</p>
                                </div>
                                <div>
                                    <p className="text-lg font-bold text-gray-900">{contratos}</p>
                                    <p className="text-xs text-blue-600">Contratos</p>
                                </div>
                                <div>
                                    <p className="text-lg font-bold text-gray-900"> {formatMoney(totalValorVencido)}</p>
                                    <p className="text-xs text-blue-600">Valor vencido</p>
                                </div>
                                <div>
                                    <p className="text-lg font-bold text-gray-900"> {formatMoney(totalValorVencer)}</p>
                                    <p className="text-xs text-blue-600">Valor a vencer</p>
                                </div>
                            </div>
                        </div>

                        {/* Orçamento WhatsApp */}
                        <div className="bg-white rounded-lg border border-gray-200 p-4">
                            <h3 className="text-sm font-medium text-blue-600 mb-3 border-l-4 border-blue-600 pl-2">Orçamento WhatsApp</h3>
                            <div className="grid grid-cols-6 gap-2">
                                <div className="bg-green-50 p-2 rounded">
                                    <p className="text-lg font-bold text-gray-900">{data?.orcamento_diario?.utility_disponivel}</p>
                                    <p className="text-xs text-green-600">Diário Disponível</p>
                                </div>
                                <div className="bg-green-50 p-2 rounded">
                                    <p className="text-lg font-bold text-gray-900">{data?.orcamento_diario?.utility_orcamento}</p>
                                    <p className="text-xs text-green-600">Diário Orçado</p>
                                </div>
                                <div>
                                    <p className="text-lg font-bold text-gray-400">{data?.orcamento_mensal?.utility_disponivel}</p>
                                    <p className="text-xs text-green-600">Mensal Disponível</p>
                                </div>
                                <div>
                                    <p className="text-lg font-bold text-gray-400">{data?.orcamento_mensal?.utility_orcamento}</p>
                                    <p className="text-xs text-green-600">Mensal Orçado</p>
                                </div>
                                <div>
                                    {/* <div className="flex items-center gap-4"> */}
                                    <div className="flex  flex-col items-center ">
                                        <label htmlFor="queue-limit" className="text-sm text-gray-600 font-semibold whitespace-nowrap">
                                            Limite Envio Whats:
                                        </label>
                                        <Input
                                            id="queue-limit"
                                            type="number"
                                            min="1"
                                            placeholder="0"
                                            value={queueLimit}
                                            onChange={(e) => setQueueLimit(e.target.value)}
                                            className="w-24 h-9 border-green-500"
                                            onBlur={(e) => limitePermitido(e.target.value)}
                                        />
                                    </div>
                                    {/* </div> */}


                                </div>

                                <div className="flex flex-col gap-2">
                                    <Button className="flex items-center gap-1 bg-green-600 hover:bg-green-700 text-white h-10 w-32" onClick={() => setIsModalOpen(true)}>
                                        <MessageCircle className="h-4 w-4" />
                                        <p className="w-32 text-center text-xs font-semibold leading-tight break-words">
                                            Gerar Campanha
                                        </p>
                                    </Button>
                                    <Button className="flex items-center gap-1 bg-green-600 hover:bg-green-700 text-white h-10 w-32" onClick={downloadCSV} disabled={campanhas?.length === 0}>
                                        <FaFileExcel className="h-4 w-4" />
                                        <p className="w-32 text-center text-xs font-semibold leading-tight break-words">
                                            Relatório de envio
                                        </p>
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
            <ModalRelatoriosWhats open={open} onOpenChange={() => setOpen(false)} />
        </div>
    );
}
